module.exports = __webpack_public_path__ + "img/20-l.dcf2c9b9.png";